function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { colors } from '../../../theme';
import { fonts } from '../../../theme';
import { createOwnUpStyle } from '../../style';
export var OwnUpCheckboxButtonIndicatorStyle = createOwnUpStyle({
  height: '24px',
  width: '24px',
  display: 'inline-block',
  border: "1px solid ".concat(colors.GREY),
  borderRadius: '2px',
  fontWeight: 'bold',
  boxSizing: 'border-box',
  paddingLeft: '3px',
  paddingTop: '1px',
  marginRight: '20px',
  verticalAlign: 'top',
  variants: {
    checked: {
      color: colors.PRIMARY,
      background: colors.PRIMARY,
      border: "1px solid ".concat(colors.PRIMARY)
    }
  }
});
export var OwnUpCheckboxStyle = createOwnUpStyle({
  // These elements are effectively hidden, but without display
  //   set to none in order to allow screen readers to still see
  //   that these are checkbox button elements. If this were to
  //   be set to not render the screen readers would only see the
  //   elements that make up the component and not the actual radio.
  '-webkit-user-select': 'none',
  '-moz-user-select': 'none',
  '-ms-user-select': 'none',
  'user-select': 'none',
  position: 'absolute',
  opacity: 0,
  height: 0,
  width: 0
});
export var OwnUpCheckboxDisplayStyle = createOwnUpStyle({
  display: 'inline-block',
  width: 'calc(100% - 44px)',
  paddingTop: '4px'
});
export var OwnUpCheckboxWrapperStyle = createOwnUpStyle(_objectSpread(_objectSpread({}, fonts.GRAPHIK_REGULAR), {}, {
  display: 'inline-block',
  position: 'relative',
  color: colors.PRIMARY_ALT,
  background: colors.WHITE,
  border: "1px solid transparent",
  borderRadius: '3px',
  padding: '16px 19px',
  margin: '5px',
  minWidth: '240px',
  width: 'calc(45% - 20px)',
  minHeight: '26px',
  verticalAlign: 'top',
  cursor: 'pointer',
  '& > *': {
    verticalAlign: 'middle'
  },
  '&[disabled]': {
    cursor: 'not-allowed',
    border: '1px solid transparent',
    color: colors.GREY
  },
  ':hover': {
    border: "1px solid ".concat(colors.PRIMARY_DISABLED),
    '& > span:first-child': {
      border: "1px solid ".concat(colors.PRIMARY_DISABLED)
    }
  },
  variants: {
    checked: {
      color: colors.PRIMARY,
      border: "1px solid ".concat(colors.PRIMARY)
    },
    smallAndDown: {
      width: 'unset',
      display: 'block',
      margin: '10px 0'
    }
  }
}));
export var OwnUpCheckBreakStyle = createOwnUpStyle({// TODO: What should this look like?
  //   We don't have styles for these yet.
});
export var OwnUpCheckGroupStyle = createOwnUpStyle(_objectSpread(_objectSpread({}, fonts.GRAPHIK_REGULAR), {}, {
  color: colors.PRIMARY,
  // To counteract the button wrapper and make sure buttons are aligned with other components
  marginLeft: '-5px',
  marginRight: '-5px'
})); // Hide the checkbox but maintain its clickability

export var OwnUpToggleStyle = createOwnUpStyle({
  opacity: '0',
  height: '14px',
  width: '46px',
  margin: '0',
  zIndex: 1
}); // The track the toggle switch slides along

export var OwnUpToggleWrapperStyle = createOwnUpStyle({
  background: colors.GREY,
  borderRadius: '10px',
  height: '14px',
  width: '46px',
  marginTop: '5px',
  padding: '0',
  display: 'flex',
  position: 'relative',
  ':focus': {
    outline: 'none'
  },
  variants: {
    on: {
      background: colors.SUCCESS,
      justifyContent: 'flex-end'
    }
  }
}); // The toggle switch

export var OwnUpToggleSwitchStyle = createOwnUpStyle({
  background: colors.WHITE,
  border: "1px solid ".concat(colors.GREY),
  borderRadius: '20px',
  height: '22px',
  width: '22px',
  marginTop: '-5px',
  position: 'absolute'
});